import { AdminExamRoomRequestComputerInfoDetails } from '@exam-center/exam-location-management';
import { PaperSection } from '@shared/components';

export default function ExamLocationRequestRoomComputerInfoEditPage() {
  return (
    <PaperSection title='ข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'>
      <AdminExamRoomRequestComputerInfoDetails />
    </PaperSection>
  );
}
